import { of } from 'rxjs';

export const breakPointServiceMock = (): any => ({
	device$: of('mobile'),
	isPC: () => false,
});
